import {Select} from 'antd';
import React, {SyntheticEvent, useEffect, useState} from "react";
import {SelectionMode} from '@models/index';
import categoryFetcherHoc from "@hocs/categoryFetcherHoc";
import {Category} from "@models/category";
import {string} from "prop-types";


const Option = Select.Option;


export interface CategoryMultiSelectionReturnValue {
  new_categories: string[];
  deleted_categories: string[];
  selectedItems: Category[]
}

export const categoryMultiSelectionDefaultReturnValue: CategoryMultiSelectionReturnValue = {
  new_categories: [],
  deleted_categories: [],
  selectedItems: []
};

type CategorySelectionProps = {
  mode: SelectionMode,
  onChange: (value: CategoryMultiSelectionReturnValue) => void
  selectedCategories: Category[],
  data: Category[],
  onScroll: (e: SyntheticEvent) => void,
  handleSearch: (query: string) => void,
  fetchData: (params: object | null) => void,
  filter?: object,
  isFetched: boolean,
  initialValue: Category[] | Category | null
}


/**
 * This class handle selection of categories
 * Use Select fro ant-design because it has on scroll option
 * In terms of lazy loading of data, selected items should bre rendered separated
 * On Change callback return an object from new and deleted categories
 * @param props
 * @constructor
 */
const CategoriesSelection: React.FC<CategorySelectionProps> = props => {
  const {handleSearch, onScroll, data = [], initialValue, onChange, fetchData, isFetched, mode = SelectionMode.DEFAULT} = props;
  const defaultValue = mode == SelectionMode.MULTIPLE ? [] : null;
  
  const retrieveValueFromProps = () => {
    if (mode == SelectionMode.MULTIPLE) {
      const returnValue = props.initialValue || [];
      return returnValue.map(item => item.id)
    }
    else {
      return props.initialValue ? props.initialValue.id : null
    }
  };
  
  const [value, setValue] = useState(initialValue ? retrieveValueFromProps() : defaultValue);
  
  useEffect(() => {
    const value = retrieveValueFromProps();
    setValue(value);
  }, [props.initialValue]);
  
  
  /**
   * To handle show selected categories before fetch data
   */
  const getData = () => {
    if (mode == SelectionMode.MULTIPLE) {
      let returnData = data;
      const selectedValues = props.initialValue || [];
      selectedValues.forEach(category => {
        if (returnData.findIndex(opt => opt.id === category.id) === -1) {
          returnData.push(category)
        }
      });
      
      return returnData;
    }
    else {
      return initialValue && !data.find(opt => opt.id == initialValue.id) ? [...data, initialValue] : data;
    }
  };
  
  const onChangeValue = (newValue, option) => {
    setValue(newValue);
    if (mode == SelectionMode.MULTIPLE) {
      const selectedValues = props.initialValue || [];
      const oldValue = selectedValues.map(cat => cat.id);
      const deleted_categories = oldValue.filter(item => newValue.findIndex(id => id === item) === -1);
      const new_categories = newValue.filter(item => oldValue.findIndex(id => id === item) === -1);
      props.onChange({
        deleted_categories,
        new_categories,
        selectedItems: option.map(opt => opt.props.category)
      });
    }
    else {
      onChange(option.props.category)
    }
  };
  
  const onFocus = () => {
    if (isFetched == false) {
      fetchData({});
    }
  };
  
  return (
    <Select
      showSearch
      mode={mode}
      value={value}
      defaultActiveFirstOption={false}
      showArrow={true}
      filterOption={false}
      onChange={onChangeValue}
      onFocus={onFocus}
      onSearch={handleSearch}
      onPopupScroll={onScroll}
      notFoundContent={null}
    >
      {getData().map(category =>
        <Option key={category.id} category={category}>{category.title}</Option>
      )}
    </Select>
  );
};

export default categoryFetcherHoc(CategoriesSelection);


